module.exports = __webpack_public_path__ + "img/tu1.5d566edb.png";